import { loginStorage } from '@/common/loginStorage'
import { register } from '@/common/rtc/srs/video-platform'
import { walkieRegist } from '@/common/rtc/srs/video-walkie'
import { loginWalkie } from '@/common/rtc/mediasoup/mediasoup-walkie'
import { loginMVCPUtil } from '@/common/rtc/mediasoup/mediasoup-util'
import { createSocket } from '@/api/websocket'
import { creatGK3Socket } from '@/common/websocket/index'
import { setSession, nowDateTime } from '@/api/common'
import { getLogin, getRecordFlag } from '@/api/login'
import { loginCollection } from '@/api/dmp/dmpCollection'

import { Message } from 'element-ui'
import md5 from 'js-md5'
import store from '@/store/index'
import i18n from '@/common/i18n'
import router from '@/router'

let rtcType = store.getters.rtcType
let isCloud = store.getters.isCloud
export function getQueryVariable(name) {
  try {
    var url = window.location.href
    if (url.indexOf('?') === -1) {
      return ''
    }
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = url.split('?')[1].match(reg)
    if (r != null) {
      return r[2]
    }
    return ''
  } catch (e) {
    return ''
  }
}
let username = ''
let rsaPassWord = ''
let validateCode = ''
let auth_type = ''
let timestamp = ''

// 请求登录接口
export function gologin() { 
  console.log('gologin', getQueryVariable('appKey') && getQueryVariable('secretKey'))
  if (getQueryVariable('appKey') && getQueryVariable('secretKey')) {
    let asideCollapse = getQueryVariable('asideCollapse') ? getQueryVariable('asideCollapse') : 'true'
    let footCollapse = getQueryVariable('footCollapse') ? getQueryVariable('footCollapse') : 'true'
    let themesStyle = getQueryVariable('themes')
    store.commit('changeHeaderCollapse', asideCollapse)
    store.commit('changeFootCollapse', footCollapse)

    username = getQueryVariable('appKey')
    let secretKey = getQueryVariable('secretKey')
    timestamp = nowDateTime()
    let passKey = secretKey + '.' + username + '.' + timestamp + '.' + secretKey
    rsaPassWord = md5(passKey)
    auth_type = 'ak_sk'

    let params = {
      data: {
        username: username,
        password: rsaPassWord,
        grant_type: 'password',
        verificationCode: validateCode,
        auth_type: auth_type,
        timestamp: timestamp,
      },
    }

    getLogin(params).then(val => {
      let state = val.state
      let res = val
      if (state === 0) {
        // 储存参数
        loginStorage(res,themesStyle)
        // 私有化请求配置 是 mediasoup 或者 SRS
        if (!store.getters.isCloud) {
          getCloudRoomUrl()
        }
        store.dispatch('alterName', res.username)

        let permsCode = sessionStorage.getItem('featureCode')
        if (permsCode) {
          createSocket()
          creatGK3Socket()
        }
        if (localStorage.getItem('theme') === null) {
          localStorage.setItem('theme', 'default')
        }

        let openNewStyle = 0
        if (res.tenantConfig) {
          if (res.tenantConfig['OPEN_NEW_STYLE']) {
            openNewStyle = res.tenantConfig['OPEN_NEW_STYLE']
          }
        }
        Message({
          type: 'success',
          message: i18n.t('loginSucceeded'),
          duration: 1000,
        })
        toRouter()
        try {
          loginCollection('SUCCESS', new Date().getTime())
          _getRecordFlag()
        } catch (error) {
          console.log(error)
        }
      } else {
        // this.errLogin(state)
      }
    })
  }
}
function toRouter() {
  let windowUrl = window.location.hash
  if (windowUrl.indexOf('Login') > -1) {
    router.push({ path: '/newIndex/newHome' })
  } else {
    let data = windowUrl.split('#')[1]
    let url = data.split('?')[0]
    router.push({ path: url })
  }
  // 更新样式引入
  import('@/style/new-index.styl')
}
function getCloudRoomUrl() {
  if (store.getters.rtcType === 'srs') {
    //  连接注册新媒体平台 服务
    register()
    walkieRegist()
  } else if (store.getters.rtcType === 'mediasoup') {
    loginWalkie()
    // 连接mediasoup
    loginMVCPUtil()
  }
}
function _getRecordFlag() {
  getRecordFlag().then(res => {
    if (res.state === 0) {
      let data = res.data
      data.forEach(element => {
        if (element.transcribe === 'TRANSCRIBE_REAL_VIDEO') {
          setSession('TRANSCRIBE_REAL_VIDEO', element.value)
        } else if (element.transcribe === 'TRANSCRIBE_LIVE') {
          setSession('TRANSCRIBE_LIVE', element.value)
        } else if (element.transcribe === 'TRANSCRIBE_LIVE_MODE') {
          store.commit('changeLiveMode', element.value)
        }
      })
    }
  })
}
